import { isUndefined } from 'lodash'
import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'

const EMOJI_AVATAR_ATTR = 'showEmojiAvatar'

const actions = {
  updateShowEmojiAvatarSetting: async ({ dispatch, rootState }, toggleValue) => {
    const presentationId = rootState?.presentation?.id
    dispatch('presentationAttributeModule/updatePresentationAttributeAction', {
      presentationId,
      payload: {
        attributeName: EMOJI_AVATAR_ATTR,
        attributeValue: toggleValue,
      },
    }, { root: true })
  },
}

const _getters = {
  canUseToggleEmojiAvatar: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-toggle-emoji-avatar')
  },
  isShownEmojiAvatar: (_, getters, rootState) => {
    const attrValue = rootState.presentationAttributeModule?.presentationAttribute?.[EMOJI_AVATAR_ATTR]
    // If undefined it should set to true because it's the current default value
    const showEmojiValue = isUndefined(attrValue) ? true : attrValue
    return getters.canUseToggleEmojiAvatar
      ? showEmojiValue
      : true
  },
}

export default {
  namespaced: true,
  actions,
  getters: _getters,
}
